import { useEffect, useRef } from 'react';
import { api } from './api';

let globalWs = null;
const listeners = new Map();
let currentHouseholdId = null;

function getWsUrl() {
  // Samme base som HTTP-laget (api.js getBase): custom server → VITE_API_URL → ''.
  // I bundlede Capacitor-builds er location.host 'localhost', så vi MÅ bruge
  // VITE_API_URL — ellers rammer WebSocket'en telefonen selv og forbinder aldrig.
  const base = localStorage.getItem('freshtrack_server_url') || import.meta.env.VITE_API_URL || '';
  if (base) {
    // Konverter http(s) → ws(s) og tilføj /ws-stien
    return base.replace(/\/+$/, '').replace(/^http/, 'ws') + '/ws';
  }
  // Web-dev (relativ via Vite-proxy)
  const proto = location.protocol === 'https:' ? 'wss' : 'ws';
  return `${proto}://${location.host}/ws`;
}

function getWs() {
  if (globalWs && globalWs.readyState <= 1) return globalWs;

  const ws = new WebSocket(getWsUrl());

  ws.onopen = () => {
    const hhId = api.getActiveHousehold();
    if (hhId) {
      ws.send(JSON.stringify({ type: 'subscribe', householdId: hhId, token: localStorage.getItem('access_token') }));
      currentHouseholdId = hhId;
    }
  };

  ws.onmessage = (e) => {
    try {
      const msg = JSON.parse(e.data);
      listeners.forEach(cb => cb(msg));
    } catch {}
  };

  ws.onclose = () => {
    globalWs = null;
    setTimeout(getWs, 3000);
  };

  globalWs = ws;
  return ws;
}

export function subscribeToHousehold(householdId) {
  if (!householdId || householdId === currentHouseholdId) return;
  currentHouseholdId = householdId;
  const ws = getWs();
  if (ws.readyState === 1) {
    ws.send(JSON.stringify({ type: 'subscribe', householdId, token: localStorage.getItem('access_token') }));
  }
}

export function useWS(onMessage) {
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;
  const id = useRef(Math.random());

  useEffect(() => {
    getWs();
    listeners.set(id.current, (msg) => cbRef.current(msg));
    return () => listeners.delete(id.current);
  }, []);
}
